import { Icon, Table, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React, { useMemo } from 'react';
import { DimensionValue, FlatList } from 'react-native';

import { TradingConsolidateItem } from '../../../../../store/trading/types';
import { makeLoadingTable } from '../../../../../utils/makeLoadingTable';

import { Head } from './components/Head';
import { TradingListItem } from './components/Item';
import { Loading } from './components/Loading';
import { rowHeight, maxHeightMobile } from './constants';

interface SentOrderListProps {
  isMobile?: boolean;
  tradingList?: TradingConsolidateItem[];
  tradingListLoading?: boolean;
  onLoadMore?: () => void;
}

const loadingCardItems = () => Array.from({ length: 1 }, (_, index) => <Loading key={index} />);

export const TradingList: React.FC<SentOrderListProps> = ({
  isMobile,
  tradingList,
  tradingListLoading,
  onLoadMore,
}) => {
  const loadingTable = useMemo(() => makeLoadingTable({ numRows: 1, numCols: 1 }), []);
  const deviceType = useBreakpointValue({ md: 'desktop', base: 'tablet' });

  const emptyTradingList = useMemo(
    () => (
      <HStack
        borderRadius="sm"
        background={Color.background}
        justifyContent="center"
        paddingY={Spacing['inset.nano']}
        marginY={Spacing['inset.xs']}
        alignContent="center"
        alignItems="center"
        paddingX={Spacing['inset.sm']}>
        <Icon testId="info-icon" name="Info" size="sm" />
        <Text>Este cliente não possui operação aberta nesta plataforma.</Text>
      </HStack>
    ),
    []
  );

  return (
    <Box flex={1}>
      <VStack flex={1} {...(isMobile && { height: maxHeightMobile?.toString() })}>
        {isMobile ? (
          <FlatList
            data={tradingList}
            windowSize={10}
            maxToRenderPerBatch={4}
            contentContainerStyle={{ height: maxHeightMobile }}
            renderItem={({ item, index }) => (
              <TradingListItem isLast={index === tradingList?.length! - 1} item={item} />
            )}
            keyExtractor={(index) => index.toString()}
            showsVerticalScrollIndicator={false}
            onEndReached={onLoadMore}
            ListFooterComponent={tradingListLoading ? <>{loadingCardItems}</> : null}
          />
        ) : (
          <Table
            isLoading={!tradingList?.length && !!tradingListLoading}
            rows={4}
            cols={7}
            rowHeight={rowHeight}
            flex={1}>
            {deviceType === 'desktop' && !!tradingList?.length && <Head />}
            <FlatList
              updateCellsBatchingPeriod={5}
              data={tradingList}
              windowSize={10}
              maxToRenderPerBatch={4}
              style={{
                flex: 1,
                marginLeft: `-${Spacing['inline.xxs']}` as DimensionValue,
                marginRight: `-${Spacing['inline.xxs']}` as DimensionValue,
              }}
              renderItem={({ item, index }) => (
                <TradingListItem isLast={index === tradingList?.length! - 1} item={item} />
              )}
              keyExtractor={(index) => index.toString()}
              showsVerticalScrollIndicator={false}
              onEndReached={onLoadMore}
              ListEmptyComponent={emptyTradingList}
              ListFooterComponent={tradingListLoading ? loadingTable : null}
            />
          </Table>
        )}
      </VStack>
    </Box>
  );
};
